// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2zYaJ","sendOtp":"AuthorizeToLogin_sendOtp__1wi8r"};